module.exports = __webpack_public_path__ + "img/5_4.78dd3e47.png";